import React, { useCallback, useContext } from 'react';
import { ReactComponent as ExcelIcon } from '@ubeya/shared-web/assets/file-excel.svg';
import { CircleIcon, Header2 } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import PrivilegesContext from '@ubeya/shared-web/contexts/PrivilegesContext';
import { exportFormattedAuditLogs } from '@ubeya/shared/utils/audit-logs';
import useProfileFieldValue from '@ubeya/shared/hooks/account/useProfileFieldValue';
import { AccordionSummaryContainer } from '@ubeya/shared-web/components/Accordion/Accordion';
import privileges from '@ubeya/shared-web/privileges';

const EmployeeRecentActionsHeader = ({ data }) => {
  const { t, dateFormat, timeFormat, shortDateMonthFormat, currency } = useContext(ConfigContext);
  const { getProfileFieldValue } = useProfileFieldValue();

  const myPrivileges = useContext(PrivilegesContext);
  const hasSensitiveDataAccess = !!myPrivileges[privileges.SENSITIVE_DATA_ACCESS];

  const onExportAuditLogs = useCallback(async () => {
    exportFormattedAuditLogs({
      t,
      auditLogs: data || [],
      dateFormat,
      timeFormat,
      shortDateMonthFormat,
      getProfileFieldValue,
      currency,
      hasSensitiveDataAccess
    });
  }, [data, dateFormat, shortDateMonthFormat, t, timeFormat, getProfileFieldValue, currency, hasSensitiveDataAccess]);

  return (
    <AccordionSummaryContainer>
      <Header2> {t('auditLogs')} </Header2>
      <CircleIcon icon={ExcelIcon} tooltip={t('exportRecentActions')} onClick={onExportAuditLogs} />
    </AccordionSummaryContainer>
  );
};

export default React.memo(EmployeeRecentActionsHeader);
